import React, { useEffect, useRef, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import Loader from '../Loader'
import swal from 'sweetalert'
import { axiosInstance } from '../Config'
import config from '../Config'
import { useNavigate } from 'react-router-dom'
import Pagination, { PerPageSelect } from '../../components/Pagination'

const avatarColors = ['#A44CD7', '#0CACC2', '#F55145', '#F9BE22', '#8A3BBD']

const GeneratedImages = () => {
    const navigate = useNavigate()

    const [allUsers, setAllUsers]           = useState([])
    const [filteredUsers, setFilteredUsers] = useState([])
    const [loading, setLoading]             = useState(false)
    const [searchQuery, setSearchQuery]     = useState("")
    const [page, setPage]                   = useState(1)
    const [itemsPerPage, setItemsPerPage]   = useState(10)

    const isFirstRender = useRef(true)

    useEffect(() => {
        document.title = "Generated Images | Mindora"
        window.scrollTo(0, 0)
        fetchData()
    }, [])

    useEffect(() => {
        if (isFirstRender.current) { isFirstRender.current = false; return }
        const q = searchQuery.trim().toLowerCase()
        setPage(1)
        setFilteredUsers(q ? allUsers.filter(u => u.username?.toLowerCase().includes(q)) : allUsers)
    }, [searchQuery])

    const fetchData = async () => {
        setLoading(true)
        try {
            const res = await axiosInstance.get('generated-images')
            const list = res.data?.data ?? res.data ?? []
            setAllUsers(list)
            setFilteredUsers(list)
        } catch {
            swal('', 'Failed to load data.', 'error')
        } finally {
            setLoading(false)
        }
    }

    const totalPages  = Math.ceil(filteredUsers.length / itemsPerPage)
    const pagedUsers  = filteredUsers.slice((page - 1) * itemsPerPage, page * itemsPerPage)

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Generated Images" description="AI images created by kids">
                <section className="ps-dashboards">
                    <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>

                        <div className="d-md-flex justify-content-between align-items-center mb-4 gap-3">
                            <div className="d-flex align-items-center gap-2">
                                <div className="ps-form--search-simple">
                                    <input
                                        className="form-control bg-white"
                                        type="text"
                                        value={searchQuery}
                                        onChange={e => setSearchQuery(e.target.value)}
                                        placeholder="Search by kid's username..."
                                    />
                                    <button type="button"><i className="icon icon-magnifier"></i></button>
                                </div>
                                <PerPageSelect itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} setPage={setPage} />
                            </div>
                            <div className="d-flex align-items-center gap-3 flex-shrink-0 mt-2 mt-md-0">
                                <button type="button" className="button"
                                    style={{ background: '#1a1a2e', color: '#fff', borderRadius: '12px' }}
                                    onClick={() => navigate(-1)}>
                                    <i className="icon-arrow-left me-2"></i>Back
                                </button>
                            </div>
                        </div>

                        <div className='table-responsive'>
                            <table className='jean-table table'>
                                <tbody>
                                    {pagedUsers.map((user, index) => (
                                        <tr key={user.id}>
                                            <td>
                                                <div className="rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{ width: 44, height: 44, background: avatarColors[index % avatarColors.length], color: '#fff', fontWeight: 700, fontSize: 16 }}>
                                                    {user.username?.[0]?.toUpperCase() || '?'}
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p className='mb-0 fw-semibold' style={{ color: '#1a1a2e' }}>{user.username}</p>
                                                    <p className='mb-0' style={{ fontSize: 12, color: '#999' }}>Age {user.age}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Parent</p>
                                                    <p className='mb-0 fw-semibold' style={{ color: '#1a1a2e' }}>{user.parent?.name || '—'}</p>
                                                    {user.parent?.email && <p className='mb-0' style={{ fontSize: 12, color: '#999' }}>{user.parent.email}</p>}
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Total Images</p>
                                                    <span className="badge rounded-pill px-3 py-1"
                                                        style={{ background: 'rgba(164,76,215,0.12)', color: '#A44CD7', fontWeight: 600, fontSize: 13 }}>
                                                        {user.totalImages ?? 0}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Last Created</p>
                                                    <p className='mb-0'>{user.lastCreated ? new Date(user.lastCreated).toLocaleDateString() : '—'}</p>
                                                </div>
                                            </td>
                                            <td className='pe-3'>
                                                <div className='d-flex justify-content-end'>
                                                    <button type="button" className="btn fw-semibold"
                                                        style={{ background: 'linear-gradient(135deg, #A44CD7, #F55145)', color: '#fff', borderRadius: 8, padding: '6px 18px', fontSize: 13, border: 'none' }}
                                                        onClick={() => navigate(`${config.appUrl}ai-generated/images/${user.userKey}`)}>
                                                        <i className="bi bi-images me-1"></i>View Images
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {filteredUsers.length === 0 && !loading && (
                                        <tr><td colSpan={6}><div className="alert alert-success ps-4 m-2">No users found!</div></td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <Pagination
                            page={page} totalPages={totalPages}
                            setPage={setPage} totalItems={filteredUsers.length}
                            showingCount={pagedUsers.length}
                        />
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default GeneratedImages
